module.exports = __webpack_public_path__ + "img/_0002_图层-4.546a1879.png";